import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import BilanPatrimoineForm from '@/components/bilan-patrimonial/BilanPatrimoineForm';
import PageMeta from '@/components/SEO/PageMeta';
import { TooltipWrapper } from "@/components/ui/tooltip";

const BilanPatrimoine = () => {
  return (
    <TooltipWrapper>
      <div className="min-h-screen flex flex-col">
        <PageMeta 
          title="Bilan Patrimonial Gratuit - La Patrimoniale"
          description="Obtenez votre bilan patrimonial gratuit avec La Patrimoniale, cabinet expert à Paris. Analyse complète de votre patrimoine, étude personnalisée de vos actifs, diagnostic fiscal, et recommandations sur l'investissement, l'assurance-vie, l'immobilier ou la transmission. Profitez de l'expertise La Patrimoniale pour optimiser et sécuriser votre avenir financier. Un conseiller La Patrimoniale vous accompagne de l'analyse à la mise en œuvre de votre stratégie patrimoniale."
          keywords="La Patrimoniale, bilan patrimonial gratuit, analyse patrimoine, diagnostic patrimonial, optimisation fiscale, stratégie patrimoniale, expertise gestion patrimoine, conseil patrimoine Paris, rendez-vous La Patrimoniale, bilan patrimoine"
          canonical="https://www.la-patrimoniale-gestion.com/bilan-patrimonial"
        />
        <Navbar />
        <main className="flex-grow pt-20 pb-16 bg-gray-50">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto">
              <h1 className="section-title text-center mb-4">Bilan Patrimonial Gratuit</h1>
              <p className="text-center text-patrimoine-muted mb-12 max-w-2xl mx-auto">
                Complétez ce formulaire pour recevoir une analyse personnalisée de votre patrimoine et des recommandations adaptées à votre situation.
              </p>

              <BilanPatrimoineForm />
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </TooltipWrapper>
  );
};

export default BilanPatrimoine;
